import { render, staticRenderFns } from "./WeightHistoryDropdown.vue?vue&type=template&id=235c16eb&"
import script from "./WeightHistoryDropdown.vue?vue&type=script&lang=js&"
export * from "./WeightHistoryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WeightHistoryDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports